import { Add } from "@mui/icons-material";
import { Button, Typography } from "@mui/material";
import { IMortgageQuote } from "../../../_common/interface/mortgageQuote/iMortgageQuote.interface";
import { MortgagesQuoteCardDesktop } from "./mortgagesQuoteCardDesktop";
import { MortgagesQuoteCardMobile } from "./mortgagesQuoteCardMobile";

export function QuoteList(params: {
    data: IMortgageQuote[],
    isMobile: boolean,
    showAll: boolean,
    onShowAll: () => void,
    onApply: (id: number, quoteId: number) => void,
    brand: any
}) {
    const sorted = [...params.data].sort((a, b) => a.monthlyPayment - b.monthlyPayment);
    const list = params.showAll ? sorted : sorted.slice(0, 10);

    return (
        <>
            {list.map((item) =>
                params.isMobile ? (
                    <MortgagesQuoteCardMobile key={item.id} item={item} brand={params.brand} onApply={params.onApply} />
                ) : (
                    <MortgagesQuoteCardDesktop key={item.id} item={item} brand={params.brand} onApply={params.onApply} />
                )
            )}

            {!params.showAll && params.data.length > 10 && (
                <Button startIcon={<Add />} variant="text" onClick={params.onShowAll}>
                    <Typography>Show More Deals</Typography>
                </Button>
            )}
        </>
    );
}
